<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ginette is a French-Canadian woman who lives in a small coastal town in Cape Breton, Nova Scotia, with her cock-a-poo, Bijou. This is Ginette’s third book, in which she shares her passion for words that can easily touch your heart. She believes that words come easily from the heart when you live so close to paradise.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7b60c0ba